module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.c4bd22eb.ttf";